'use strict'

import plainPassword from 'assets/themes/campings/js/module/plainPassword'
import dataLayer from 'assets/core/js/page/red-booking/customer-zone/dataLayer'
import paymentScheduleToggle from 'assets/themes/campings/js/page/red-booking/customer-zone/paymentScheduleToggle'
import cancellationPages from 'assets/themes/campings/js/page/red-booking/customer-zone/cancellationPages'

const currentPageType = document.body.getAttribute('data-pagetype') as string

document.addEventListener('DOMContentLoaded', function () {
  if (/(customer-zone-subscribe|customer-zone-login|customer-zone-new-password)/.test(currentPageType)) {
    plainPassword.init()
  }

  dataLayer()
  paymentScheduleToggle()
  cancellationPages()
})
